export default __webpack_public_path__ + "static/media/customer_ob_on.29678b40.svg";